import React, { useMemo } from "react";
import { BackButton, ErrorWithString, SuccessWithString } from "../../../../../components/RegularComponents";
import "../../BLTInformation.styles.scss"

export const PaymentHistoryDetails = (props) => {
    const { details, setDetails } = props
    const handleGoBack = () => {
        setDetails()
    }

    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <div className="licence-application-details-panel">
                <DetailSection data={details} />
            </div>

        </div>
    )
}

const DetailSection = ({ data }) => {

    const status = useMemo(() => {
        return data.transactionStatus === "COMPLETED" ?
            (<span className="has-success">{SuccessWithString("Complete", { fontWeight: "bold", fontSize: "1.1rem" })}</span>) :
            (<span className="ns-error-message field-validation-error">{ErrorWithString(status, { fontWeight: "bold", fontSize: "1.1rem" })}</span>)
    }, [data])

    const totalAmount = useMemo(() => {
        return parseFloat(data.totalFee).toFixed(2)
    }, [data])

    const applicationsIncluded = useMemo(() => {
        return data.transactionHistoryItemList.map((item, index) => {
            return <p key={index}>- {item.itemDescription}</p>
        })
    }, [data])


    return (
        <>
        {/* Payment Status */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Status</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {status}
            </div>
        </div>
        {/* Payment date */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Payment date</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {data.transactionDate}
            </div>
        </div>
        {/* Payment Type */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Payment Type</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {`${data.paymentType ?? "N/A"}`}
            </div>
        </div>
        {/* Transaction ID */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Transaction ID</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {`${data.transactionNumber}`}
            </div>
        </div>
        {/* Applications Included */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Applications included</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex", flexDirection: "column" }}>
                {applicationsIncluded}
            </div>
        </div>
        {/* Total */}
        <div className="row section-row-margin">
            <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
                <span>Total</span>
            </div>

            <div className="collector-licence-col col-md-6" style={{ display: "flex" }}>
                {`$${totalAmount}`}
            </div>
        </div>
        </>
    )
}